// // components/AgricultureHero/AgricultureHero.jsx
// import React from 'react';
// import './AgricultureHero.css';

// const AgricultureHero = () => {
//   return (
//     <section className="agriculture-hero">
//       <div className="agriculture-hero-overlay">
//         <div className="agriculture-hero-content">
//           <h1>Fostering Agricultural Growth</h1>
//           <p>Empowering local farmers and boosting food security through sustainable practices.</p>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AgricultureHero;

import React from 'react';
import './AgricultureHero.css';

const AgricultureHero = () => {
  return (
    <section className="agri-hero">
      <div className="agri-hero-overlay">
        <div className="agri-hero-content">
          <h1>Agricultural Empowerment</h1>
          <p>Driving food security and prosperity through innovation, support, and modern practices.</p>
        </div>
      </div>
    </section>
  );
};

export default AgricultureHero;